var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("section", [
        _c("div", { staticClass: "flex-between" }, [
          _c("h2", { staticClass: "inner-headers" }, [_vm._v(" ")]),
          _vm._v(" "),
          _c("div", { staticStyle: { padding: "24px 30px 10px 10px" } }, [
            _c(
              "button",
              {
                staticClass: "second",
                on: {
                  click: function($event) {
                    _vm.openedFilters = true
                  }
                }
              },
              [
                _c("i", { staticClass: "el-icon-s-operation" }),
                _vm._v(" Filters")
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("applied-filters", {
        attrs: { filters: _vm.appliedFilters },
        on: {
          clear: function($event) {
            return _vm.clearFilters()
          },
          remove: function($event) {
            return _vm.removeFilter($event)
          }
        }
      }),
      _vm._v(" "),
      _c("section", { staticClass: "content-tlist" }, [
        _c(
          "table",
          { staticClass: "content-table" },
          [
            _c(
              "tr",
              [
                _vm._l(_vm.header, function(item, i) {
                  return _c("th", [_vm._v(_vm._s(item))])
                }),
                _vm._v(" "),
                _c("th", [_vm._v("Options")])
              ],
              2
            ),
            _vm._v(" "),
            _vm._l(_vm.registrations, function(registration) {
              return _c(
                "tr",
                { key: registration.id },
                [
                  _vm._l(registration, function(item, i) {
                    return _c(
                      "td",
                      { key: i },
                      [
                        i == "data"
                          ? [
                              _vm.isEdit(registration.id)
                                ? _c("textarea", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.itemData,
                                        expression: "itemData"
                                      }
                                    ],
                                    attrs: { cols: "40", rows: "10" },
                                    domProps: { value: _vm.itemData },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.itemData = $event.target.value
                                      }
                                    }
                                  })
                                : [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item) +
                                        "\n              "
                                    )
                                  ]
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        i == "createdBy"
                          ? [item ? [_vm._v(_vm._s(item.id))] : _vm._e()]
                          : [_vm._v(_vm._s(item))]
                      ],
                      2
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c("span", [_vm._v("Options")]),
                      _vm._v(" "),
                      _vm.isEdit(registration.id)
                        ? [
                            _c(
                              "button",
                              {
                                staticClass: "action-button save",
                                on: {
                                  click: function($event) {
                                    return _vm.saveUpdate(registration)
                                  }
                                }
                              },
                              [_vm._v("Save")]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "action-button cancel",
                                on: {
                                  click: function($event) {
                                    return _vm.cancelEdit(registration.id)
                                  }
                                }
                              },
                              [_vm._v("Cancel")]
                            )
                          ]
                        : !_vm.editStatus
                        ? [
                            _c(
                              "button",
                              {
                                staticClass: "action-button update",
                                on: {
                                  click: function($event) {
                                    return _vm.edit(registration)
                                  }
                                }
                              },
                              [_vm._v("Edit")]
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ],
                2
              )
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "pagination-section" }, [
        _c("div", [
          _vm._v("\n      Per page\n      "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.perPage,
                  expression: "perPage"
                }
              ],
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.perPage = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  function($event) {
                    return _vm.setPages()
                  }
                ]
              }
            },
            [
              _c("option", { attrs: { value: "25" } }, [_vm._v("25")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "50" } }, [_vm._v("50")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "75" } }, [_vm._v("75")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "100" } }, [_vm._v("100")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "150" } }, [_vm._v("150")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "200" } }, [_vm._v("200")])
            ]
          )
        ]),
        _vm._v(" "),
        _c("nav", { attrs: { "aria-label": "Page navigation example" } }, [
          _c("ul", { staticClass: "pagination" }, [
            _c("li", { staticClass: "page-item" }, [
              _vm.page != 1
                ? _c(
                    "button",
                    {
                      staticClass: "page-link",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.page--
                        }
                      }
                    },
                    [_vm._v(" Previous ")]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "page-item" },
              _vm._l(_vm.pages.slice(_vm.page - 1, _vm.page + 5), function(
                pageNumber
              ) {
                return _c(
                  "button",
                  {
                    key: pageNumber,
                    staticClass: "page-link",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.page = pageNumber
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(pageNumber) + " ")]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("li", { staticClass: "page-item" }, [
              _vm.page < _vm.pages.length
                ? _c(
                    "button",
                    {
                      staticClass: "page-link",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.page++
                        }
                      }
                    },
                    [_vm._v(" Next ")]
                  )
                : _vm._e()
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.openedFilters
        ? _c("profile-filters", {
            attrs: { filters: _vm.filters },
            on: {
              apply: function($event) {
                return _vm.applyFilters($event)
              },
              close: function($event) {
                _vm.openedFilters = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }